import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatRemaining } from './session';

const ANNOUNCE_AT_MS = 60 * 1000;

// Remaining time of the ack session, counted down from the end returned by back-hia. Silent for screen readers
// except once at one minute left; calls onExpire when it reaches zero.
const SessionCountdown = ({ sessionEnd, onExpire, now = Date.now }) => {
    const [remaining, setRemaining] = useState(() => sessionEnd - now());
    const expiredRef = useRef(false);

    useEffect(() => {
        const tick = () => {
            const left = sessionEnd - now();
            setRemaining(left);
            if (left <= 0 && !expiredRef.current) {
                expiredRef.current = true;
                if (onExpire) onExpire();
            }
        };
        tick();
        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, [sessionEnd, onExpire, now]);

    const announce = remaining > 0 && remaining <= ANNOUNCE_AT_MS;
    return (
        <span className="hia-ack-countdown" data-testid="session-countdown">
            <span aria-live="off">
                <FormattedMessage id="conventionPage.session.remaining" values={{ time: formatRemaining(remaining) }} />
            </span>
            <span className="hia-ack-sr-only" aria-live="polite">
                {announce ? <FormattedMessage id="conventionPage.session.remainingAnnounce" /> : null}
            </span>
        </span>
    );
};

export default SessionCountdown;
